import * as types from './types';
import {
  ToolBookStatementStocksList,
  ToolBookStatementStocksSalesModel
} from 'src/model/AdminModel';

export default{
  actionToolBookStatementStocksList({commit, state}, query){
    if (state.toolBookStatementStocksList.state === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_TOOL_BOOK_STATEMENT_STOCKS_LIST, {
      state: 'loading'
    });
    return ToolBookStatementStocksList.getInstance().execute(query).then((response) => {
      commit(types.ACTION_TOOL_BOOK_STATEMENT_STOCKS_LIST, {
        state: 'loadend',
        list: response.list,
        sale_return_export_url: response.sale_return_export_url,
        total : response.total
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_TOOL_BOOK_STATEMENT_STOCKS_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
  actionToolBookStatementStocksSalesModel(store,query){
    return ToolBookStatementStocksSalesModel.getInstance().execute(query);
  },
}






// WEBPACK FOOTER //
// ./src/store/Admin/modules/inventoryManagement/actions.js